import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from 'projects/clinician/src/app/utilitites/api-end-point-constants';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class ShellService {
    constructor(private apiService: ApiService,private http: HttpClient) {}

    public getVersions() : Observable<any>{
        return this.apiService.get(ClinicianApiEndPointConstants.helpAboutApi);
    }

    // callTrustArcScan(locale) {
    //     return this.http.get(environment.trustArcUrl + '/' + environment.trustArcToken + '&locale=' + locale);
    // }

    // loadTrustArc(userLang?: string): void {

    //     let trustArcUrl = environment.trustArcUrl;
    //     let trustArcToken = environment.trustArcToken;

    //     if (trustArcUrl && trustArcToken) {

    //         let trustArcSrc = `${trustArcUrl}${trustArcToken}`;

    //         if (userLang) {
    //             trustArcSrc += userLang === 'zh' ? '&locale=zh_HANS' : `?locale=${userLang}`;
    //         }
    //         //console.log('TrustArc Src: ' + trustArcSrc);

    //         // Angular-Compatible Script Loader - TODO revisit with Renderer2
    //         const script = document.createElement('script');
    //         script.src = trustArcSrc;
    //         script.async = true;
    //         script.onerror = (error) => {
    //             console.error('TrustArc script load error:', error);
    //         };

    //         document.head.appendChild(script);
    //     }
    // }
}
